<template>
    <div id="main">
        <div class="registry-wrapper" v-if="idMotivoAtendimento > 0">
            <div class="page">
                <div class="vertical-flow">
                    <div class="filters-bar mb-3">
                        <div class="filters-bar-form form-columns-fit">
                            <div class="columns">
                                <div class="column is-12">
                                    <vss-select
                                        :id="generateId(1)"
                                        ref="listaFormularioSelect"
                                        title="selecione"
                                        label="titulo"
                                        placeholder="selecione"
                                        v-model="formFormularioSelected"
                                        :options="formFormularioSelect"
                                        :loading="isLoading"
                                        @input="handleFormSelectionChange"
                                        :disabled="isEdit"
                                    >
                                        <template v-slot:option="{ option }">
                                            <span 
                                                class="option-label" 
                                                :class="{'teste' : option.obrigatorio}" 
                                                :title="getLabelRepeticao(option)"
                                            >
                                                {{ getLabelRepeticao(option) }}
                                            </span>
                                        </template>
                                    </vss-select>
                                </div>
                            </div>
                        </div>
                        <div class="filters-bar-actions">
                            <b-button
                                v-if="isEdit && formRespostaCabecalhoSituacao != 1"
                                type="is-primary"
                                icon-right="marker-check"
                                @click="finalizarFormRespostaCabecalho"
                                :disabled="isFinalizar || isSaving || situacaoAtendimento != 0"
                                :loading="isFinalizar"
                                v-tippy 
                                :title="$t('finalizar')"
                            />
                            <b-button
                                :class="'ml-2'"
                                v-if="formRespostaCabecalhoSituacao != 1"
                                type="is-primary"
                                icon-right="content-save"
                                @click="save"
                                :disabled="isFinalizar || isSaving || formFormularioSelected == null || situacaoAtendimento != 0"
                                :loading="isSaving"
                                v-tippy 
                                :title="$t('salvar')"
                            />
                            <b-button
                                :class="'ml-2'"
                                type="is-primary"
                                icon-right="view-list"
                                @click="changeToFormListingPage"
                                :disabled="isSaving"
                                v-tippy 
                                :title="$t('listagem')"
                            />
                        </div>
                    </div>
                    <div>
                        <loader v-if="formularioAtendimentoLoading || !isLoaded" />
                        <!-- Área de Perguntas e Respostas -->
                        <div class="questions-answers-section" v-else-if="formFormularioSelected != null">
                            <div v-if="formFormulario != null && formFormulario.formGrupoPerguntaList != null">
                                <question-group-component
                                    style="margin-bottom: 5px"
                                    v-for="group in formFormulario.formGrupoPerguntaList"
                                    :key="group.id"
                                    :group="group"
                                    :isFinalizado="formRespostaCabecalhoSituacao == 1"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <h1 class="is-size-5 has-text-centered">
                {{ $t("sem-motivo-vinculado-para-este-atendimento") }}
            </h1>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssMotivoAtendimentoFormFormularioService from "@/services/AssMotivoAtendimentoFormFormularioService";
import FormFormularioService from "@/services/FormFormularioService";
import FormRespostaCabecalhoService from "@/services/FormRespostaCabecalhoService";

// COMPONENTS
import QuestionGroupComponent from "@/components/shared/QuestionGroupComponent.vue";
import FormComponent from "@/components/shared/FormComponent.vue";

export default {
    name: "FormAnswer",
    components: {
        QuestionGroupComponent,
        FormComponent,
    },
    props: {
        situacaoAtendimento: {
            type: Number,
            default: 0,
        },
        cameFrom: {
            type: String,
            default: "route",
        },
        uuidFrom: {
            type: String,
            default: "",
        },
        idMotivoAtendimento: {
            type: Number,
            default: 0,
        },
        idEmpresa: {
            type: Number,
            default: 0,
        },
        formularioCameFromList: {
            type: Object,
            default: null,
        },
    },
    computed: {
        origemId() {
            // Verificar se o ID foi passado como parâmetro ou query, dependendo do seu caso de uso
            return this.$route.params.origemId;
        },
        tituloId() {
            return this.$route.params.id;
        },
    },
    data() {
        return {
            assFormularioGeralTabelaIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                "ASS_FORM_FORMULARIO_GERAL_TABELA"
            ),

            formFormulario: null,
            formGrupoPergunta: [],
            formPergunta: [],
            formRespostaItem: [],
            perPage: 50,

            respostaSelecionadas: [],

            formularioAtendimentoLoading: false,

            uuidFormRespostaCabecalho: "",

            formFormularioSelected: null,
            formFormularioSelect: [],
            assMotivoAtendimentoFormService: new AssMotivoAtendimentoFormFormularioService(this.$http, this.$router),
            formFormularioService: new FormFormularioService(this.$http, this.$router),
            formRespostaCabecalhoService: new FormRespostaCabecalhoService(this.$http, this.$router),
            permissao: false,
            isLoading: false,
            isEmpty: false,
            isEdit: false,
            debouncedOnSearch: null,
            queryFilter: "",
            column: "titulo",
            order: "asc",
            isSaving: false,
            delete: null,

            multipleOptions: ["CHECKBOX", "SWITCH"],
            multipleOptionsIgnoreSituacao: ["RADIO", "COMBOBOX"],
            hasInvalid: false,
            formRespostaCabecalho: {
                idEmpresa: null,
                idUsuario: null,
                idFormFormulario: null,
                dataHoraCriacao: null,
                dataHoraFinalizacao: null,
                latitude: null,
                longitude: null,
                direcao: null,
                lastfix: null,
                pdot: null,
                satelites: null,
                velocidade: null,
                tipoGps: null,
                origem: "WEBFV",
                obrigatorio: null,
                assFormRespostaCabecalhoGeralTabela: {
                    uuidFormRespostaCabecalho: null,
                    uuidTabelaFrom: null,
                    geralTabela: "crm_atendimento",
                },
                assFormRespostaCabecalhoFormPerguntas: [],
            },
            formRespostaCabecalho: null,
            isLoaded: false,
            formRespostaCabecalhoSituacao: 0,
            isFinalizar: false,
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess("vendas", "crm", "ven-atendimento");

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: {
                    tela: "ven-atendimento",
                },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();

            if (this.formularioCameFromList != null && this.formularioCameFromList.id != undefined) {
                this.formFormularioSelected = this.formularioCameFromList;
                this.isEdit = true;
                this.handleFormSelectionChange();
            } else {
                this.isLoaded = true;
            }
        }
    },
    methods: {
        /* successPosition(position){
            this.formRespostaCabecalho.latitude = (position.coords.latitude)?position.coords.latitude:0;
            this.formRespostaCabecalho.longitude = (position.coords.longitude)?position.coords.longitude:0;
            this.formRespostaCabecalho.lastfix = (position.timestamp)?position.timestamp:null;
            this.formRespostaCabecalho.tipogps = (position.coords.latitude)?1:0;
            console.info(position);
            this.save();
        },
        errorPosition(e){
            console.error('Geolocation error!', e);
            this.save();
        },

        preSave() {
            this.isSaving = true;
            if (navigator.geolocation) {
                console.log('Geolocation is supported by this browser');
                navigator.geolocation.getCurrentPosition(this.successPosition, this.errorPosition);
            } else {
                console.log('Geolocation is not supported by this browser');
                this.save();
            }
        }, */
        changeToFormListingPage() {
            this.$emit("mostrarFormulario");
        },
        save() {
            this.isSaving = true;
            this.isLoading = true;

            this.formRespostaCabecalho = this.fillData();

            this.formRespostaCabecalhoService
                .save(this.formRespostaCabecalho)
                .then((body) => {
                    // const response = body.content;
                    this.$root.showMessage("success", this.$t("msg-sucesso-salvar"), true, false);

                    if (this.isFinalizar) {
                        this.finalizar();
                    } else {
                        this.$emit('isChanged');
                        setTimeout(() => {
                            this.changeToFormListingPage();
                        }, 1000);
                    }
                })
                .catch((e) => {
                    console.error("Erro ao salvar formulario.", e);

                    if (e.body.message) {
                        this.$root.showMessage("alert", e.body.message, true);
                    } else {
                        this.$root.showMessage("error", "msg-problema-realizar-acao");
                    }
                })
                .finally((_) => {
                    setTimeout(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    }, 1000);
                });
        },
        fillData() {
            this.formFormulario.formGrupoPerguntaList.forEach((formGrupoPergunta) => {
                formGrupoPergunta.formPerguntaList.forEach((formPergunta) => {
                    formPergunta.formRespostaItemList.forEach((formRespostaItem) => {
                        if (this.isNull(formRespostaItem.formRespostaPreenchida.resposta)) {
                            this.hasInvalid = true;
                        }
                    });
                });
            });

            const formRespostaCabecalho = {
                uuid: this.formFormulario.uuidFormRespostaCabecalho,
                id_empresa: this.idEmpresa,
                id_usuario: this.$store.state.user.usuario.idusuario,
                id_form_formulario: this.formFormulario.id,
                latitude: 0,
                longitude: 0,
                direcao: 0,
                lastfix: 0,
                pdot: 0,
                satelites: 0,
                velocidade: 0,
                tipoGps: 0,
                origem: "WEBFV",
                obrigatorio: 0,
                assFormRespostaCabecalhoGeralTabela: {
                    uuid: this.formFormulario.uuidAssFormRespostaCabecalhoGeralTabela,
                    uuid_tabela_from: this.uuidFrom,
                    geral_tabela: "crm_atendimento",
                },
                assFormRespostaCabecalhoFormPerguntaList: this.getAssFormRespostaCabecalhoFormPerguntas(),
            };

            return formRespostaCabecalho;
        },
        getAssFormRespostaCabecalhoFormPerguntas() {
            let assFormRespostaCabecalhoFormPerguntaList = [];

            this.formFormulario.formGrupoPerguntaList.forEach((formGrupoPergunta) => {
                formGrupoPergunta.formPerguntaList.forEach((formPergunta) => {
                    const assFormRespostaCabecalhoFormPergunta = {
                        uuid: formPergunta.uuidAssFormRespostaCabecalhoFormPergunta,
                        id_form_pergunta: formPergunta.id,
                        formRespostaPreenchidaList: this.getFormRespostaPreenchidas(formPergunta.item_tipo, formPergunta.formRespostaItemList),
                    };

                    assFormRespostaCabecalhoFormPerguntaList.push(assFormRespostaCabecalhoFormPergunta);
                });
            });
            return assFormRespostaCabecalhoFormPerguntaList;
        },
        getFormRespostaPreenchidas(itemTipo, formRespostaItemList) {

            let formRespostaPreenchidaList = [];
                    
            formRespostaItemList.forEach((formRespostaItem) => {
                if (
                    ["SWITCH", "CHECKBOX"].includes(itemTipo)
                ) {
                    if (formRespostaItem.formRespostaPreenchida.situacao) {
                        formRespostaItem.formRespostaPreenchida.resposta = formRespostaItem.descricao;
                        this.setFormRespostaPreenchida(itemTipo, formRespostaItem, formRespostaPreenchidaList);
                    }
                } else if (formRespostaItem.formRespostaPreenchida.resposta) {
                    this.setFormRespostaPreenchida(itemTipo, formRespostaItem, formRespostaPreenchidaList);
                }
            });

            return formRespostaPreenchidaList;
        },
        setFormRespostaPreenchida(itemTipo, formRespostaItem, formRespostaPreenchidaList) {
            const uuid = formRespostaItem.formRespostaPreenchida.uuid;
            const formRespostaPreenchida = {
                uuid: uuid ? uuid : "",
                id_form_resposta_item: formRespostaItem.id,
                resposta: this.formatResposta(itemTipo, formRespostaItem.formRespostaPreenchida.resposta),
            };
            formRespostaPreenchidaList.push(formRespostaPreenchida);
        },
        formatResposta(itemTipo, resposta) {
            if (
                ["DECIMAL", "PERCENT"].includes(itemTipo)
            ) {
                return parseFloat(resposta).toFixed(2);
            } else {
                return resposta;
            }
        },
        carregarDados() {
            this.isLoading = true;
            this.assMotivoAtendimentoFormService
                .findAssFormGeral(
                    this.idMotivoAtendimento,
                    "crm_motivo_atendimento"
                )
                .then((response) => this.carregarListagemFormularios(response))
                .then((mappedItems) => {
                    this.formFormularioSelect = mappedItems;
                    this.isEmpty = this.formFormularioSelect.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage("error", "msg-erro-load");
                    console.error("Erro ao carregar formulario de perguntas e respostas.");
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        // pega o formulário respondido
        carregarDadosByUuid() {
            this.isLoading = true;
            this.assMotivoAtendimentoFormService
                .findRespondidoByUuid(this.formFormularioSelected.formRespostaCabecalhoUuid)
                .then((response) => {
                    this.formRespostaCabecalho = response.content;
                    this.formRespostaCabecalhoSituacao = this.formRespostaCabecalho.situacao;
                })
                .catch((e) => {
                    this.formRespostaCabecalho = null;
                    this.$root.showMessage("error", "msg-erro-load");
                })
                .finally((_) => {
                    this.isLoading = false;
                    if (this.formRespostaCabecalho != null) {
                        this.injetaRespostas();
                    }
                });
        },

        injetaRespostas() {
            if (this.formFormulario != null) {

                this.formFormulario.uuidFormRespostaCabecalho = this.formRespostaCabecalho.uuid;
                this.formFormulario.uuidAssFormRespostaCabecalhoGeralTabela =
                    this.formRespostaCabecalho.assFormRespostaCabecalhoGeralTabela.uuid;

                this.formFormulario.formGrupoPerguntaList.forEach((formGrupoPergunta) => {
                    formGrupoPergunta.formPerguntaList.forEach((formPergunta) => {
                        let temp1 = this.formRespostaCabecalho.assFormRespostaCabecalhoFormPerguntaList.find(
                            (assFormRespostaCabecalhoFormPergunta) => {
                                return assFormRespostaCabecalhoFormPergunta.id_form_pergunta == formPergunta.id
                            }
                        );

                        if (temp1 != undefined) {

                            formPergunta.uuidAssFormRespostaCabecalhoFormPergunta = temp1.uuid;
                            
                            formPergunta.formRespostaItemList.forEach((formRespostaItem) => {
                                let temp2 = temp1.formRespostaPreenchidaList.find(
                                    (formRespostaPreenchida) => {
                                        return formRespostaPreenchida.id_form_resposta_item == formRespostaItem.id
                                    }
                                );
                                if (temp2 != undefined) {
                                    formRespostaItem.formRespostaPreenchida = temp2;
                                }
                            });
                        }
                    });
                });
                this.$forceUpdate();
                this.isLoaded = true;
            } else {
                this.hasInvalid = true;
                this.isLoaded = true;
            }
        },

        setFormGrupoPergunta(formFormulario) {
            this.formGrupoPerguntaList = formFormulario.formGrupoPerguntaList;
        },

        handleFormSelectionChange() {
            if (this.formFormularioSelected != null) {
                this.formularioAtendimentoLoading = true;
                this.carregarFormularioPerguntas(this.formFormularioSelected.id);
            }
        },
        // pega a estrutura do formulário
        carregarFormularioPerguntas(idAtendimento) {
            this.formFormularioService
                .find(idAtendimento, "ven")
                .then((data) => {
                    this.formFormulario = data.content;
                })
                .catch((error) => {
                    this.formFormulario = null;
                    this.$root.showMessage("error", "Problemas ao carregar os detalhes do formulário");
                })
                .finally(() => {
                    this.formularioAtendimentoLoading = false;
                    if (this.isEdit) {
                        this.carregarDadosByUuid();
                    } else {
                        this.isLoaded = true;
                    }
                });
        },

        updateValueMotivoAtendimento(motivoAtendimento) {
            this.motivoAtendimentoSelected = motivoAtendimento;

            this.removeFocus();

            if (this.motivoAtendimentoSelected != null) {
                this.$emit("idMotivoAtendimento", this.motivoAtendimentoSelected.id);
                this.mapHabilita();
                this.mapObriga();
            }
        },

        removeFocus() {
            for (const refName in this.$refs) {
                if (this.$refs[refName]) {
                    this.$refs[refName].focusedOut = false;
                }
            }
        },

        carregarListagemFormularios(response) {
            return response.content.map((item) => {
                const obrigatorio = item.formFormulario.obrigatorio;
                return {
                    id: item.formFormulario.id,
                    titulo: item.formFormulario.titulo + (obrigatorio ? ' *' : ''),
                    uuid: item.formFormulario.uuid,
                    obrigatorio: item.obrigatorio,
                    situacao:item.formFormulario.situacao
                };
            });
        },

        mapFormularioPerguntas(response) {
            return response.content.map((item) => {
                return {
                    id: item.formFormulario.id,
                    titulo: item.formFormulario.titulo,
                    uuid: item.formFormulario.uuid,
                    formGrupoPerguntaList: item.formGrupoPerguntaList,
                };
            });
        },

        finalizarFormRespostaCabecalho() {
            this.isFinalizar = true;

            this.hasInvalid = this.validateFormularioFinalizar();

            if (this.hasInvalid) {
                this.isFinalizar = false;
                this.$root.showMessage("alert", "msg-campos-obrigatorios", true);
            } else {
                this.save();
            }

        },
        finalizar() {
            const uuidFormulario = this.formRespostaCabecalho.uuid;
            this.formRespostaCabecalhoService
                .finalizar(uuidFormulario)
                .then((_) => {
                    // const response = body.content;
                    this.$root.showMessage("success", this.$t("msg-sucesso-finalizar"), true, false);
                    setTimeout(() => {
                        this.changeToFormListingPage();
                    }, 1000);
                })
                .catch((e) => {
                    console.error("Erro ao salvar formulario.", e);

                    if (e.body.message) {
                        this.$root.showMessage("alert", e.body.message, true);
                    } else {
                        this.$root.showMessage("error", "msg-problema-realizar-acao");
                    }
                })
                .finally((_) => {
                    setTimeout(() => {
                        this.isFinalizar = false;
                        this.isLoading = false;
                    }, 1000);
                });
        },
        validateFormularioFinalizar() {
            if (!this.formFormulario) {
                return true;
            }

            const hasInvalidResponse = this.formFormulario.formGrupoPerguntaList.some(formGrupoPergunta => {
                return formGrupoPergunta.formPerguntaList.some(formPergunta => {
                    if (!formPergunta.obrigatorio) return false;
                    if (this.multipleOptions.includes(formPergunta.item_tipo)) {
                        return !formPergunta.formRespostaItemList.some(f =>
                            !this.isNull(f.formRespostaPreenchida.resposta) && f.formRespostaPreenchida.situacao
                        );
                    } else if (this.multipleOptionsIgnoreSituacao.includes(formPergunta.item_tipo)) {
                        return !formPergunta.formRespostaItemList.some(f =>
                            !this.isNull(f.formRespostaPreenchida.resposta)
                        );
                    } else {
                        return formPergunta.formRespostaItemList.some(formRespostaItem => {
                            return this.isNull(formRespostaItem.formRespostaPreenchida.resposta);
                        });
                    }
                });
            });

            return hasInvalidResponse;
        },
        generateId(numberId) {
            return this.$route.name + "-geral-" + numberId;
        },

        getLabelRepeticao(option) {
            if (option == null) return;
            let label = option.titulo;
            if (option.obrigatorio) {
                label += ' *';
            }
            return label;
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0;
    height: auto;
    .page {
        height: 100%;
        position: relative;
        padding-left: 0;

        // Barra de filtro
        .filters-bar {
            display: flex;
            .filters-bar-form {
                flex-grow: 1;
            }
            .filters-bar-actions {
                display: flex;
                padding-bottom: 2px;
                align-items: stretch;
            }

            @media screen and (min-width: 851px) {
                .filters-bar-actions {
                    align-self: flex-end;
                    margin-left: 10px;
                    margin-bottom: 12px;
                }
            }
            @media screen and (max-width: 850px) {
                flex-direction: column;
                .filters-bar-actions {
                    align-self: center;
                    margin-top: 10px;
                }
            }
        }

        .questions-answers-section {
            margin-bottom: 80px;
        }
    }

}
.teste {
    color: $orange-alert;
}
</style>
